import * as z from "zod/v4";
import { literal } from "zod/v4";
import { ConfirmProductVisualizationSchema } from "../../agents/support-agents/confirm-product-visualization";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";

/**
 * Message type for when the AI wants the customer to upload a photo
 * for product visualization
 */
const ProductVisualizationUploadMessageSchema =
  BaseToolCallMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_VISUALIZATION_UPLOAD_UI),
    structuredContent: ConfirmProductVisualizationSchema.optional(),
  });

export type ProductVisualizationUploadMessage = z.infer<
  typeof ProductVisualizationUploadMessageSchema
>;

export const ProductVisualizationUploadMessageDbParser =
  ProductVisualizationUploadMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductVisualizationUploadMessageType = z.infer<
  typeof ProductVisualizationUploadMessageDbParser
>;
